import Date from './Date';
import ReservationPopup from './ReservationPopup';
import TimeSelectionPage from './TimeSelectionPage';
import TimePopup from './TimePopup';
import BookingFormPage from './BookingFormPage';
import DietaryPopup from './DietaryPopup';
import OccasionsPopup from './OccasionsPopup';
import CheckoutPage from './CheckoutPage';
import ThreeDSRoutes from "./providers/3ds/ThreeDSRoutes";
import WebSocket from './providers/Websocket'
import ScrollToTop from './providers/ScrollToTop'

import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
  

 import MainHeader from './MainPage/MainHeader'
 import Mp4 from './MainPage/Mp4'
 import FarFromPage from './MainPage/FarFromPage'
 import Photo1 from './MainPage/Photo1'
 import Photo2 from './MainPage/Photo2'
 import Photo3 from './MainPage/Photo3'
  import Photo4 from './MainPage/Photo4'

 import BigText from './MainPage/BigText'

 
 
function App() {
  return (
    <div className="App">
    
   
  
<Router>
        <ScrollToTop />
      <WebSocket />
  <Routes>
      <Route path='/' element={<>
      
       <MainHeader/>
              <Mp4/>
              <FarFromPage/>
              <Photo1/>
               <Photo2/>  
                    <Photo3/>
                      <Photo4/>

                  <BigText/>


      </>}/>

      <Route path='/date' element={<>
      
       <Date/>
      
      </>}/>
      <Route path='/time' element={<>
      
          <TimeSelectionPage/>

      
      </>}/>
    

 <Route path='/booking' element={<>
      
          <BookingFormPage/>

      
      </>}/>

       <Route path='/checkout' element={<>
      
          <CheckoutPage/>

      
      </>}/>
{ThreeDSRoutes()}
      </Routes>
      </Router>

    </div>
  );
}

export default App;
 